import { Badge } from "./badge";
import { FileQuestion } from "lucide-react";

interface DraftBadgeProps {
  status?: string;
  className?: string;
  showIcon?: boolean;
}

/**
 * Display a badge indicating draft status
 */
export function DraftBadge({ status, className = '', showIcon = true }: DraftBadgeProps) {
  if (status !== 'draft') {
    return null;
  }

  return (
    <Badge 
      variant="outline" 
      className={`bg-yellow-50 text-yellow-700 border-yellow-300 ${className}`}
    >
      {showIcon && <FileQuestion className="h-3 w-3 mr-1" />}
      Draft
    </Badge>
  );
}

export default DraftBadge;

